module.exports = __webpack_public_path__ + "images/landing/vehicle/watercraft-storage--jet-ski.jpg";